import { render } from "./Explore.vue?vue&type=template&id=c46490b8&scoped=true"
import script from "./Explore.vue?vue&type=script&lang=js"
export * from "./Explore.vue?vue&type=script&lang=js"

import "./Explore.vue?vue&type=style&index=0&id=c46490b8&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46490b8"]])

export default __exports__